import { IList, IRecord } from 'annotation-tools/utils';
import {
  APIRawValidationErrorType,
  APIValidationErrorType,
  IAPIValidationErrorType
} from '../common/validation-error';
import {
  KoumutenAPIRawRequestBodyType,
  KoumutenAPIRequestBodyType
} from './api-request-body';

export type KoumutenAPIRawSuccessResponseType = {
  id: number;
  name: string; // [1..50] characters
  company_count: number;
  author: string;
  can_be_deleted: boolean;
  created_at: string;
  updated_at: string;
};

export type KoumutenAPIRawValidationErrorType = APIRawValidationErrorType<
  KoumutenAPIRawRequestBodyType
>;

export type KoumutenAPIValidationErrorType = APIValidationErrorType<
  KoumutenAPIRequestBodyType
>;

export type IKoumutenAPIValidationErrorType = IAPIValidationErrorType<
  KoumutenAPIRequestBodyType
>;

export const IKoumutenAPIValidationErrorFactory = IRecord<
  KoumutenAPIValidationErrorType
>({
  name: IList<string>()
});
